"use strict";

(function () {
  console.log('gtm-events script connected');

  if (!window.jQuery) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  var checkout_step = window.Shopify.Checkout ? getCheckoutStep() : '';
  var active_currency = window.Shopify.Checkout ? window.Shopify.Checkout.currency : window.Shopify.currency.active;

  if (checkout_step && checkout_step.value !== 'checkout_thank_you') {
    $.ajax('/cart.json', {
      method: 'GET',
      success: function success(data) {
        window.event_data.checkout = data.items;
        trackCheckout();
      }
    });

    if (window.login_href) {
      var redirect_uri = "".concat(window.location.protocol, "//").concat(window.location.hostname);
      var extra_data = "".concat(window.location.pathname).concat(window.location.search);
      $('a[href*="/account/login"]').attr('href', "".concat(window.login_href, "&redirect_uri=").concat(encodeURIComponent(redirect_uri), "&extraData=").concat(encodeURIComponent(extra_data)));
    }
  }

  $(document).on('click', '[data-product-url-click]', function (e) {
    var $link = $(e.currentTarget);
    var product_data = JSON.parse($link.attr('data-product-url-click'));
    var usd_price = window.Currency.convert(product_data.price, active_currency, 'USD');
    product_data.price = "".concat((usd_price / 100).toFixed(2));
    window.dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: {
          products: [product_data]
        }
      }
    });
  });
  $(document).on('click', '[data-product-add]', function (e) {
    e.preventDefault();
    var $form = $(e.currentTarget).parents('form[action="/cart/add"]');
    trackAddToCart($form);
    $form.submit();
  });
  $(document).on('click', '.th-do-add-to-cart', function (e) {
    var $button = $(e.currentTarget);
    var products = [];
    var $product = $button.parents('.th-do-crossellProduct');
    var product_title = $product.find('.th-do-title a').text();
    var variant_id = $product.find('.th-do-variants select').val() || $product.find('input[name="variants_id"]').val();
    var variant_price = $product.find('.th-do-originalPrice').html().split('$').join('').split('.').join('');
    var variant_title = $product.find('.th-do-variants select').find("option[value=\"".concat(variant_id, "\"]")).html();
    products.push({
      name: product_title,
      id: variant_id,
      price: "".concat((window.Currency.convert(variant_price, active_currency, 'USD') / 100).toFixed(2)),
      brand: 'PADI',
      category: 'Gear',
      variant: variant_title || product_title,
      quantity: 1
    });
    trackAddToCart(null, products);
  });
  $(document).on('click', 'form[action="/cart"] [name="checkout"]', function (e) {
    var $form = $(e.currentTarget).parents('form[action="/cart"]');
    trackCheckout($form);
  });
  $(document).on('click', '[data-cart-item-remove]', trackRemoveFromCart);

  if ($('.template-product').length > 0) {
    trackProductDetailView();
  }

  function getCheckoutStep() {
    var step_els = document.getElementsByClassName('step');

    if (step_els.length == 0) {
      return;
    }

    var step = step_els[0].getAttribute('data-step');

    switch (step) {
      case 'contact_information':
        return {
          value: 1,
          option: 'Contact Information'
        };

      case 'shipping_method':
        return {
          value: 2,
          option: 'Shipping Address'
        };

      case 'payment_method':
        return {
          value: 3,
          option: 'Payment / Review'
        };

      default:
        return {
          value: 'checkout_thank_you',
          option: 'Thank you'
        };
    }
  }

  function trackProductDetailView() {
    var $form = $('[data-section-id="product"] form[action="/cart/add"]');
    window.dataLayer.push({
      event: 'productDetailView',
      ecommerce: {
        detail: {
          products: getProducts($form)
        }
      }
    });
  }

  function trackRemoveFromCart(e) {
    var $product = $(e.currentTarget).parents('[data-cart-item-wrapper]');
    var variant_id = $product.find('[data-cart-item-remove]').attr('data-item-id');
    var items = event_data.cart.items;
    var item = items.filter(function (item) {
      return item.id == variant_id;
    })[0];
    window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: [getCartProduct(item)]
        }
      }
    });
  }

  function trackAddToCart($form, products) {
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: window.Shopify.currency ? active_currency : '',
        add: {
          products: products ? products : getProducts($form)
        }
      }
    });
  }

  function trackCheckout($form) {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: $form ? {
            step: 0,
            option: 'Proceed to checkout'
          } : {
            step: checkout_step.value,
            option: checkout_step.option
          },
          products: $form ? getCartProducts() : getCheckoutProducts()
        }
      }
    });
  }

  function getCartProducts() {
    var cart_products = [];
    var items = event_data.cart.items;
    items.forEach(function (item) {
      cart_products.push(getCartProduct(item));
    });
    return cart_products;
  }

  function getCartProduct(item) {
    return {
      name: item.product_title,
      id: item.variant_id,
      price: "".concat((window.Currency.convert(item.price, active_currency, 'USD') / 100).toFixed(2)),
      brand: 'PADI',
      category: 'Gear',
      variant: item.title,
      quantity: item.quantity
    };
  }

  function getCheckoutProducts() {
    var checkout_products = [];
    var items = event_data.checkout;
    items.forEach(function (item) {
      checkout_products.push(getCartProduct(item));
    });
    return checkout_products;
  }

  function getProducts($form) {
    var products = [];
    var form_data = $form.serializeArray().reduce(function (result, input) {
      result[input.name] = input.value;
      return result;
    }, {});
    var product = JSON.parse($('[data-product-json]').attr('data-product-json')); // cannot get variant from form if only one variant and has Default Title

    var variant = product.variants.filter(function (variant) {
      return variant.id == form_data.id;
    })[0] || product.variants[0];
    products.push({
      name: product.title,
      id: variant.id,
      price: "".concat((window.Currency.convert(variant.price, active_currency, 'USD') / 100).toFixed(2)),
      brand: 'PADI',
      category: 'Gear',
      variant: variant.title,
      quantity: form_data.quantity || 1
    });
    return products;
  }
})();